export const productTypeNames: Record<string, string> = {
  MR: "core-product-type-meeting-room",
  WS: "core-product-type-workstation",
  PO: "core-product-type-private-office",
  EE: "core-product-type-exclusive-office",
  EV: "core-product-type-event",
  PO_ON_DEMAND: "core-product-type-private-office-on-demand",
  MR_EXCLUSIVE: "core-product-type-meeting-room-exclusive",
};

export const productTypeIds: Record<string, number> = {
  MR: 4,
  WS: 1,
  PO: 6,
  EE: 3,
  EV: 5,
  PO_ON_DEMAND: 2,
  MR_EXCLUSIVE: 8,
  EE_ON_DEMAND: 7,
};

export const productTypeCharacteristics: Record<
  string,
  { name: string; description: string; color: string; hexaColor: string }
> = {
  1: {
    name: "core-product-type-workstation-short",
    description: "core-product-type-workstation-short-description",
    color: "sunlight-500",
    hexaColor: "#FFD282",
  },
  4: {
    name: "core-product-type-meeting-room-short",
    description: "core-product-type-meeting-room-short-description",
    color: "peach-500",
    hexaColor: "#F9A96E",
  },
  5: {
    name: "core-product-type-event-short",
    description: "core-product-type-event-short-description",
    color: "ocean-500",
    hexaColor: "#2549A4",
  },
  3: {
    name: "core-product-type-exclusive-office-short",
    description: "core-product-type-exclusive-office-short-description",
    color: "sunlight-700",
    hexaColor: "#A4854E",
  },
  6: {
    name: "core-product-type-private-office-short",
    description: "core-product-type-private-office-short-description",
    color: "coral-700",
    hexaColor: "#904646",
  },
};
